require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-7-copywriting-mistakes-costing-you-sales.json") })
        }
      }, "path---tapd-in-7-copywriting-mistakes-costing-you-sales");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-7-copywriting-mistakes-costing-you-sales!./.cache/json/tapd-in-7-copywriting-mistakes-costing-you-sales.json
// module id = 805
// module chunks = 231608221292675